export default {"src":"/_next/static/media/integrations-mob.7909278e.svg","height":547,"width":352,"blurWidth":0,"blurHeight":0};